import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useLayoutEffect, useMemo, useRef, } from 'react';
import clsx from 'clsx';
import MuiChip from '@material-ui/core/Chip';
import { DeleteCircle } from '@ringcentral/juno-icon';
import { combineClasses, isRcElement, omit, removeClassName, overridableStyled, useForkRef, useThemeProps, } from '../../foundation';
import { RcIconButton } from '../Buttons/IconButton';
import { ChipStyle } from './styles';
import { RcChipClasses } from './utils';
var _RcChip = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcChip' });
    var AvatarProp = props.Avatar, deleteTooltip = props.deleteTooltip, deleteAutomationId = props.deleteAutomationId, isError = props.isError, backgroundColor = props.backgroundColor, classesProp = props.classes, _a = props.avatar, avatarProp = _a === void 0 ? AvatarProp : _a, _b = props.error, error = _b === void 0 ? isError : _b, id = props.id, label = props.label, disabled = props.disabled, deleteIconProp = props.deleteIcon, deleteIconProps = props.deleteIconProps, tabIndex = props.tabIndex, focused = props.focused, color = props.color, className = props.className, rest = __rest(props, ["Avatar", "deleteTooltip", "deleteAutomationId", "isError", "backgroundColor", "classes", "avatar", "error", "id", "label", "disabled", "deleteIcon", "deleteIconProps", "tabIndex", "focused", "color", "className"]);
    var innerRef = useRef(null);
    var chipRef = useForkRef(innerRef, ref);
    var combinedClasses = useMemo(function () { return combineClasses(RcChipClasses, classesProp); }, [classesProp]);
    var classes = useMemo(function () { return omit(combinedClasses, ['focused']); }, [combinedClasses]);
    var deleteIcon = useMemo(function () {
        return deleteIconProp ? (React.cloneElement(deleteIconProp, __assign({ tabIndex: -1 }, deleteIconProps))) : (React.createElement(RcIconButton, __assign({ tabIndex: -1, disabled: disabled, variant: "plain", size: "medium", title: deleteTooltip, color: error ? 'danger.f02' : undefined, "data-test-automation-id": deleteAutomationId, symbol: DeleteCircle }, deleteIconProps)));
    }, [
        deleteIconProp,
        deleteIconProps,
        disabled,
        deleteTooltip,
        error,
        deleteAutomationId,
    ]);
    var avatar = useMemo(function () {
        if (avatarProp) {
            if (React.isValidElement(avatarProp) &&
                isRcElement(avatarProp, ['RcAvatar']) &&
                // * if that size is equal to default size medium
                // * that mean user not want to custom that
                avatarProp.props.size === 'medium') {
                return React.cloneElement(avatarProp, {
                    size: 'xxsmall',
                });
            }
            return avatarProp;
        }
        return undefined;
    }, [avatarProp]);
    // TODO: can be removed when upgrade to v5
    // * need remove not need MuiChip-deletable for render correct
    useLayoutEffect(function () {
        removeClassName(innerRef, 'MuiChip-deletable');
    });
    return (React.createElement(MuiChip, __assign({ ref: chipRef, id: id, tabIndex: disabled ? -1 : tabIndex, label: label, disabled: disabled, classes: classes, className: clsx(className, focused ? combinedClasses.focused : undefined), avatar: avatar, deleteIcon: deleteIcon, "data-test-automation-class": "selected-item", "data-test-automation-value": id ? id : label, "data-is-error": error }, rest)));
});
var RcChip = overridableStyled(_RcChip)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ChipStyle);
RcChip.defaultProps = {
    tabIndex: 0,
    // FIXME: after implement click state, that can be remove
    clickable: false,
};
RcChip.displayName = 'RcChip';
export { RcChip };
var templateObject_1;
